export default __webpack_public_path__ + "6c90942f627e6fbb9ffb695c437446ac.svg";